import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, border-style, #root {
    height: 100vh;
  }


  body {
    background: rgb(248, 248, 248);
    /* background:#fff; */
    /* background: #F6F9FC; */
    /* background: #f1f5f9; */
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  ul {
    list-style: none;
  }

  .swal-overlay {
  }
 
  .swal-modal {
    border-bottom: 3px solid white;
  }

  .swal-title {
    /* margin: 0px; */
    font-size: 16px;
    /* box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.21); */
    /* margin-bottom: 28px; */
    padding-bottom: 15px;
  }
  
  .swal-text {
    border-top: 1px solid #d3d3d3;
    /* background-color: #FEFAE3; */
    font-family: 'Poppins';
    padding: 17px;
    display: block;
    margin: 22px;
    text-align: center;
  }

  .swal-footer {
  }

  .swal-button {
    /* padding: 7px 19px; */
    border-radius: 6px;
    background-color: #1565c0;
    /* font-size: 12px; */
    /* border: 1px solid #3e549a; */
    /* text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.3); */

    &:hover {
      background-color: red;
    }
  }

  button {
    /* border: none; */
    /* background: transparent; */
  }

  a {
    text-decoration: none;
  }
`
